export const loanColor = '#D8F67F';
export const cashColor = '#FF96C8';
